<template>
  <div class="chart-registrations-by-status">
    <div class="thumbnail" style="margin-bottom: 0">
      <loading v-if="!chartOptions"/>
      <highcharts v-else :options="chartOptions" ref="highcharts"></highcharts>
    </div>
  </div>
</template>

<script>
  import * as config from '../../config.js'
  import {mapState, mapActions} from 'vuex'

  export default{
    name: 'ChartRegistrationsByStatus',
    components: {},
    data () {
      return {
        chartOptions: false
      }
    },
    computed: {
      apiDomain () {
        return config.apiDomain
      },
      ...mapState({
        user: state => state.user
      })
    },
    mounted () {
      this.getData()
    },
    methods: {
      getData () {
        this.loadRegistrationsByStatus({ companyId: this.user.company.id })
        .then((response) => {
          this.chartOptions = {
            chart: {
              plotBackgroundColor: null,
              plotBorderWidth: null,
              plotShadow: false,
              height: 300,
              type: 'pie'
            },
            title: {
              text: 'Situação geral dos <b>cadastros</b>'
            },
            subtitle: {
              text: 'Cadastros agrupadas por situação'
            },
            plotOptions: {
              pie: {
                allowPointSelect: true,
                cursor: 'default',
                dataLabels: {
                  enabled: true,
                  format: '{point.percentage:.0f}%',
                  distance: 10
                },
                showInLegend: true
              }
            },
            series: [{
              name: 'Quantidade',
              colorByPoint: true,
              data: response.data
            }],
            credits: {
              style: {
                color: '#fff'
              }
            }
          }
        }, (error) => {
          console.log(error)
        })
      },
      ...mapActions(['loadRegistrationsByStatus'])
    }
  }
</script>


// WEBPACK FOOTER //
// ChartRegistrationsByStatus.vue?3c6c81c5